import { parse as parseQs } from "qs";
import React from "react";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { BatchHistoryUrlQueryParams } from "./urls";
import BatchHistoryDetails from "./views/BatchHistoryDetails";
import BatchHistoryList from "./views/BatchHistoryList";

const BatchHistory = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <BatchHistoryList params={params} />;
};

const BatchHistoryDetailsComponent = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substr(1));
  const params: BatchHistoryUrlQueryParams = qs;

  return <BatchHistoryDetails params={params} id={decodeURIComponent(id)} />;
};

const Component = () => (
  <>
    <Routes>
      <Route path={""} element={<BatchHistory />} />
      <Route path={":id"} element={<BatchHistoryDetailsComponent />} />
    </Routes>
  </>
);

export default Component;
